module.exports = __webpack_public_path__ + "static/media/drag-lines.44f68c3b.svg";